// AUTO-GENERATED — do not edit.
// Source: business/ishvaram/data/governance/intent_offer_alignment.yaml
// Regenerate: uv run python execution/generate_intent_offer_ts.py

/** A page-intent and the offer it must sell (message-match contract, rule 40). */
export interface IntentOfferRule {
  intent: string;
  pageArchetypes: string[];
  primaryOffer: string;
  secondaryOffers: string[];
  /** The offer that must stay surfaced on this intent's pages — never buried. */
  neverBury: string;
  lifecycleStage: string;
}

export const INTENT_OFFER_RULES: IntentOfferRule[] = [
  {
    "intent": "chat",
    "pageArchetypes": [
      "ai_astrologer",
      "free_astrology_chat",
      "chat_landing",
      "ai_jyotish",
      "talk_to_astrologer",
      "chat_with_astrologer"
    ],
    "primaryOffer": "quick",
    "secondaryOffers": [
      "monthly",
      "day_pass",
      "brihat_kundali"
    ],
    "neverBury": "quick",
    "lifecycleStage": "conversion"
  },
  {
    "intent": "dosha_remedy",
    "pageArchetypes": [
      "sade_sati",
      "mangal_dosh",
      "kaal_sarp_dosh",
      "pitra_dosh",
      "dosha_page",
      "dosha_report",
      "shani"
    ],
    "primaryOffer": "dosha_remedy_plan",
    "secondaryOffers": [
      "brihat_kundali",
      "quick"
    ],
    "neverBury": "dosha_remedy_plan",
    "lifecycleStage": "conversion"
  },
  {
    "intent": "matching",
    "pageArchetypes": [
      "kundali_milan",
      "compatibility",
      "matching_tool",
      "gun_milan",
      "marriage_report",
      "astrologer_for_marriage_problem"
    ],
    "primaryOffer": "marriage_report",
    "secondaryOffers": [
      "brihat_kundali",
      "quick"
    ],
    "neverBury": "marriage_report",
    "lifecycleStage": "conversion"
  },
  {
    "intent": "birth_chart",
    "pageArchetypes": [
      "free_kundali",
      "birth_chart",
      "kundali",
      "janam_kundli",
      "numerology",
      "name_numerology"
    ],
    "primaryOffer": "brihat_kundali",
    "secondaryOffers": [
      "quick",
      "starter"
    ],
    "neverBury": "brihat_kundali",
    "lifecycleStage": "conversion"
  },
  {
    "intent": "career",
    "pageArchetypes": [
      "career",
      "career_report",
      "career_finance",
      "job",
      "business",
      "career_astrology_consultation"
    ],
    "primaryOffer": "career_report",
    "secondaryOffers": [
      "brihat_kundali",
      "quick"
    ],
    "neverBury": "career_report",
    "lifecycleStage": "conversion"
  },
  {
    "intent": "timing",
    "pageArchetypes": [
      "panchang",
      "muhurat",
      "choghadiya",
      "shubh_muhurat"
    ],
    "primaryOffer": "muhurat_report",
    "secondaryOffers": [
      "quick",
      "day_pass"
    ],
    "neverBury": "muhurat_report",
    "lifecycleStage": "conversion"
  },
  {
    "intent": "forecast",
    "pageArchetypes": [
      "rashifal",
      "horoscope",
      "annual_forecast_page",
      "year_ahead",
      "daily_horoscope"
    ],
    "primaryOffer": "annual_forecast",
    "secondaryOffers": [
      "monthly",
      "brihat_kundali"
    ],
    "neverBury": "annual_forecast",
    "lifecycleStage": "conversion"
  },
  {
    "intent": "festival_ritual",
    "pageArchetypes": [
      "festival",
      "puja",
      "vrat",
      "festival_ritual"
    ],
    "primaryOffer": "muhurat_report",
    "secondaryOffers": [
      "quick",
      "brihat_kundali"
    ],
    "neverBury": "muhurat_report",
    "lifecycleStage": "conversion"
  },
  {
    "intent": "pitra_dosh_report",
    "pageArchetypes": [
      "pitra_dosh_report",
      "pitra_dosha_report"
    ],
    "primaryOffer": "pitra_dosh",
    "secondaryOffers": [
      "brihat_kundali",
      "quick"
    ],
    "neverBury": "pitra_dosh",
    "lifecycleStage": "conversion"
  },
  {
    "intent": "sade_sati_report",
    "pageArchetypes": [
      "sade_sati_report",
      "shani_report"
    ],
    "primaryOffer": "sade_sati",
    "secondaryOffers": [
      "brihat_kundali",
      "quick"
    ],
    "neverBury": "sade_sati",
    "lifecycleStage": "conversion"
  },
  {
    "intent": "mahadasha_forecast",
    "pageArchetypes": [
      "mahadasha",
      "dasha_calculator",
      "mahadasha_forecast_page"
    ],
    "primaryOffer": "mahadasha_forecast",
    "secondaryOffers": [
      "annual_forecast",
      "brihat_kundali"
    ],
    "neverBury": "mahadasha_forecast",
    "lifecycleStage": "conversion"
  }
];

export function offerRuleForArchetype(archetype: string): IntentOfferRule | null {
  return INTENT_OFFER_RULES.find((r) => r.pageArchetypes.includes(archetype)) ?? null;
}

export function primaryOfferForIntent(intent: string): string | null {
  return INTENT_OFFER_RULES.find((r) => r.intent === intent)?.primaryOffer ?? null;
}
